// Virtual viewport for our game logic
export const game_width = 480;
export const game_height = 270;
// export const game_width = 256;
// export const game_height = 192;
export const render_width = 272;
export const render_height = 195;

export const VIEWPORT_X0 = 204;
export const VIEWPORT_Y0 = 3;

export const SANITY_W = 38;
